export const MODAL = 'MODAL'
export const BUTTON = 'BUTTON'
export const FILTER = 'FILTER'
export const INFINITE_SCROLL = 'INFINITE SCROLL'
export const INPUTS = 'INPUTS'
export const SIDEBAR = 'SIDEBAR'
export const CHECKBOX = 'CHECKBOX'
export const DROPDOWN = 'DROPDOWN'
export const TAB = 'TAB'
export const TOGGLE = 'TOGGLE'
